export default __webpack_public_path__ + "static/media/1759863457281-nuvio_greene5a4cc6.694750e4.png";